<h2 mat-dialog-title i18n>Select languages for translation</h2>

<mat-dialog-content>
  <mat-selection-list aria-label="Languages">
    @for (lang of data.languages; track lang.id) {
      <mat-list-option
        [selected]="selected.has(lang.locale)"
        (click)="toggle(lang.locale)"
      >
        {{ lang.name }} ({{ lang.locale }})
      </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()" i18n>Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" i18n>
    Save
  </button>
</mat-dialog-actions>
